import type { WarningName } from '~/models'

export const useWarning = () => {
  const AnimationName = 'horizontal-shake'
  const AnimationDuration = 500
  const notEmptyWarningsSelector =
    '[data-warning]:not([data-warning-dont-shake="true"])'

  const scrollToWarning = (element: Element) => {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
    })
  }

  const shakeWarnings = (warnings: NodeListOf<Element>) => {
    if (warnings.length) {
      scrollToWarning(warnings[0])

      warnings.forEach((element) => {
        element.classList.add(AnimationName)
        setTimeout(
          () => element.classList.remove(AnimationName),
          AnimationDuration,
        )
      })
    }
  }

  const payAttentionToWarning = (warning: WarningName) => {
    const warnings = document.querySelectorAll(`[data-warning='${warning}']`)

    shakeWarnings(warnings)
  }

  const payAttentionToWarnings = () => {
    const warnings: NodeListOf<Element> = document.querySelectorAll(
      notEmptyWarningsSelector,
    )

    shakeWarnings(warnings)
  }

  return {
    payAttentionToWarnings,
    payAttentionToWarning,
  }
}
